export const AFFIX_OFFSET = 85;

// Technology evolution stage configuration
export const TECH_STAGE_CONFIG = {
    embryonic_stage: {
        key: 'report.embryonicStage',
        order: 1,
    },
    development_period: {
        key: 'report.developmentPeriod',
        order: 2,
    },
    technological_maturity: {
        key: 'report.technologicalMaturity',
        order: 3,
    },
} as const;
